import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as Apis from '../../apis';
import * as actions from './create-change-request-actions';
import { getCodesFromDetailState } from '@/app/common/conversation/sagas';

export function* createChangeRequest(action) {
  try {
    const codes = yield select(getCodesFromDetailState);
    const response: Apis.IPostChangeRequestResponse = yield call(Apis.createChangeRequest, { ...action.payload, ...codes });
    yield put(actions.createChangeRequestSuccess({
      purchaseOrderItemId: action.payload.purchaseOrderItemId,
      stateId: action.payload.stateId,
      changeRequestAlreadyExistsForItems: response.changeRequestAlreadyExistsForItems
    }));
  } catch (error) {
    yield put(actions.createChangeRequestFailure(error));
  }
}

export function* watchCreateChangeRequestSaga() {
  yield takeLatest([actions.CREATE_CHANGE_REQUEST.REQUEST], createChangeRequest);
}
